// @ts-expect-error ts-migrate(7016)
import SaveReportButton from 'reporting-action-components/reportingActions/saveReport/SaveReportButton';
import { getValidatedPrimaryTracker } from '../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ActionSaveReport({
  report
}) {
  const primaryTracker = getValidatedPrimaryTracker();
  return /*#__PURE__*/_jsx(SaveReportButton, {
    report: report,
    appUsageTracker: primaryTracker
  });
}